import React from 'react';

const ImageCard = ({ image }) => {
  return <></>;
};

export default ImageCard;
